import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Istage } from '../../../../framework/Istage';
import { MapKeyConstant } from '../../../class/MapKeyConstant';
import { CommonLayout } from '../../../layout/common.layout.const';
import { TutorialDesktopPosition } from '../../../constant/tutorial.desktop.position';
import { TranslateService } from '@ngx-translate/core';
import { FontTranslationProp } from '../../../constant/fonttranslationprop';
import { UtilService } from '../../../util/UtilService';
import { TutorialPortraitPosition } from '../../../constant/tutorial.portrait.position';
import { TutorialsPortraitProps } from '../../../constant/tutorialsportraitprops';
import { FirebaseAnalyticsService } from '../../../services/firebaseanalytics.service';
import { FirebaseConstant } from '../../../constant/firebase.constant';
import { Settings } from './../../../models/settings/settings';
import { PageConstant } from 'src/app/constant/page.constant';

@Component({
    selector: 'app-fc21tutorialsmobile',
    templateUrl: './fc21tutorials.mobile.component.html',
    styleUrls: ['./fc21tutorials.mobile.component.scss'],
    standalone: false
})
export class FC21TutorialsMobileComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (event.key.toLowerCase() == 'escape') {
      this.buttonClick('close');
    }
    if (
      event.key.toLowerCase() == 'arrowleft' ||
      event.key.toLowerCase() == 'uikeyinputleftarrow'
    ) {
      this.buttonClick('left');
    }
    if (
      event.key.toLowerCase() == 'arrowright' ||
      event.key.toLowerCase() == 'uikeyinputrightarrow'
    ) {
      this.buttonClick('right');
    }
  }
  @Input() language: any = 'en';
  @Input() display: number = 1;
  @Input() overlayScreenDisplay: number = -1;
  @Input() layoutdata: Istage = {
    stageWidth: 720,
    stageHeight: 1280,
    stageLeft: 0,
    stageTop: 0,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'visible',
  };
  @Input() scaleR: any = {
    scale: 1,
    scaleX: 1,
    scaleY: 1,
    offsetLeft: 0,
    offsetTop: 0,
  };
  @Input() canPlayGame;
  @Input() data;
  @Input() tutorialPageCount: number = 0;
  @Input() helpContentStage: Istage = {
    stageWidth: 720,
    stageHeight: 1280,
    stageLeft: 0,
    stageTop: 0,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'visible',
    name: 'updatescale',
  };
  @Input() helpCloseStage: Istage;
  @Input() navKey: string;
  @Input() currentQuickTipsID = -1;
  @Input() rouletteScore;
  @Input() isSplit5to10 = true;
  @Input() currentSplitCardObj;
  @Input() superNaturalCardObj;
  @Input() doubleNaturalCardObj;
  @Input() naturalZeroCardObj;
  @Input() isDisplayAllButtons: boolean = true;
  @Output() tutorialsChange: EventEmitter<object> = new EventEmitter<object>();
  @Output() tutorialPageCountemit: EventEmitter<any> = new EventEmitter<any>();
  paysContentFont;
  percentageContentFont;
  paysContentFontSize;
  percentageContentFontSize;
  fontTranslationConst;
  tutorialPortraitPropsConst;
  scalVal = 1;
  touchStartVal = 0;
  touchMoveVal = 0;
  touchX = 0;
  touchY = 0;
  scaleWidth = 0;
  scaleHeight = 0;
  minusXValue = 0;
  minusYValue = 0;
  scalValOnEnd = 0;
  scaleValOnTouchEnd = 0;
  splitCard1 = 'green_5';
  splitCard2 = 'blue_5';
  superNaturalCard1 = 'green_11';
  superNaturalCard2 = 'orange_11';
  doubleNaturalCard1 = 'white_7';
  doubleNaturalCard2 = 'white_7';
  naturalZeroCard1 = 'white_5';
  naturalZeroCard2 = 'blue_5';
  cardsOptions;
  public settingsContentStage: Istage;
  /*"LANG00783":"Pays 1 to 1",
   "LANG00784":"Pays 2 to 1",
   "LANG00785":"Pays 3 to 1",
   "LANG00786":"Pays 3 to 2",
   "LANG00787":"Pays 4 to 1",
   "LANG00788":"Pays 5 to 1",
   "LANG00789":"Pays 6 to 5",
   "LANG00790":"Pays 7 to 2",
   "LANG00791":"Pays 7 to 5",
   "LANG00792":"Pays 8 to 5",
   "LANG00793":"Pays 9 to 5",*/
  public tutorialCount: number = 0;
  public TotalTutorialCount: number = 20;

  public tutorialClickArrayFromParent = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21,
  ];
  public tutorialClickArray = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  ];
  public tutorialClickArrayHebrew = [
    10, 11, 12, 13, 14, 15, 16, 17, 18, 1, 2, 3, 4, 5, 6, 7, 8, 9,
  ];
  public imgBackGround: string = 'Tutorial_Background@2x.webp';
  public pays_blank_tutorial: object;

  helpContentStageNoResizeChild: Istage = {
    stageWidth: 720,
    stageHeight: 600,
    stageLeft: 0,
    stageTop: 317,
    stageZ: 1005,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  helpContentRRStageNoResizeChild: Istage = {
    stageWidth: 720,
    stageHeight: 600,
    stageLeft: -2,
    stageTop: 357,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  helpContentRRStageNoResizeChild1: Istage = {
    stageWidth: 720,
    stageHeight: 600,
    stageLeft: -2,
    stageTop: 357,
    stageZ: 1000,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  impossibleSplitsContentStageNoResizeChild: Istage = {
    stageWidth: 720,
    stageHeight: 600,
    stageLeft: 0,
    stageTop: 336,
    stageZ: 1005,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };
  quickKeysContentStageNoResizeChild: Istage = {
    stageWidth: 661,
    stageHeight: 532,
    stageLeft: 28,
    stageTop: 338,
    stageZ: 1005,
    position: 'absolute',
    overflow: 'hidden',
    isChildResize: false,
  };

  splittopcardsposition: any = {};
  splitcardsposition: any = {};
  rouletteposition: any = {};
  quickkeysheaderposition: any = {};
  handcardtutorialposition: any = {};

  public tutorialContent: any = {
    TN_image_0: 'Tutorial_00_Index@2x.webp',
    TN_image_1: 'Tutorial_01_Introduction@2x.webp',
    TN_image_2: 'Tutorial_02_Scores@2x.webp',
    TN_image_3: 'Tutorial_03_GameAction@2x.webp',
    TN_image_4: 'Tutorial_04_GameRules@2x.webp',
    TN_image_5: 'Tutorial_05_Soft17@2x.webp',
    TN_image_6: 'Tutorial_06_StartAGame@2x.webp',
    TN_image_7: 'Tutorial_07_NaturalHands@2x.webp',
    TN_image_8: 'Tutorial_08_SNWins@2x.webp',
    TN_image_9: 'Tutorial_09_N21Wins@2x.webp',
    TN_image_10: 'Tutorial_10_DNWins@2x.webp',
    TN_image_11: 'Tutorial_11_NZWins@2x.webp',
    TN_image_12: 'Tutorial_12_BustOver22@2x.webp',
    TN_image_13: 'Tutorial_13_Splits_5-9@2x.webp',
    TN_image_14: 'Tutorial_14_ImpossibleSplits@2x.webp',
    TN_image_15: 'Tutorial_15_DoubleDown@2x.webp',
    TN_image_16: 'Tutorial_16_ColorInsurance@2x.webp',
    TN_image_17: 'Tutorial_17_WhiteInsurance@2x.webp',
    TN_image_18: 'Tutorial_18_Russian_Roulette@2x.webp',
    TN_image_19: 'Tutorial_19_PremiumPayouts@2x.webp',
    TN_image_20: 'Tutorial_AboutUs@2x.webp',
    TN_image_21: 'Tutorial_QuickKeys@2x.webp',
    TN_image_22: 'Tutorial_General@2x.webp',
    TN_image_23: 'Tutorial_General_No_RTP@2x.webp',
  };
  public percentageContent: Object = {
    100: 'LANG00885',
    120: 'LANG00891',
    140: 'LANG00893',
    150: 'LANG00888',
    200: 'LANG00886',
    250: 'LANG00414',
    300: 'LANG00887',
    350: 'LANG00892',
    400: 'LANG00889',
    450: 'LANG00895',
    500: 'LANG00890',
  };
  mapKeyConstant: any = MapKeyConstant.FC21KEYS;
  _subscriptionScale;
  version = '';
  constructor(
    public translate: TranslateService,
    public _utilService: UtilService,
    public firebaseAnalyticsServices: FirebaseAnalyticsService
  ) {
    //console.log("data.currentLanguage",this.language);
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subscriptionScale');
      // console.log(value);
      this.scaleR = value;
    });
    this.settingsContentStage = CommonLayout.HELP_CONTENT_PORTRAIT;
    this.settingsContentStage.stageTop = 460;
    this.settingsContentStage.stageHeight = 387;
    this.settingsContentStage.stageZ = 994;
    this.scaleWidth = 720;
    this.scaleHeight = 526;
    this.minusXValue = 20;
    this.minusYValue = 70;
    this.splittopcardsposition = TutorialPortraitPosition.SPLITTOPCARDSPOSITION;
    this.splitcardsposition = TutorialPortraitPosition.SPLITCARDSPOSITION;
    this.rouletteposition = TutorialPortraitPosition.ROULETTEPOSITION;
    this.quickkeysheaderposition =
      TutorialPortraitPosition.QUICKKEYSHEADERPOSITION;
    this.handcardtutorialposition =
      TutorialPortraitPosition.HANDCARDTUTORIALPOSITION;
    this.version = PageConstant.VERSION;
  }

  ngOnChanges(data) {
    //console.log('changing ---------mobile', data);
    if (data.isSplit5to10) {
      this.isSplit5to10 = data.isSplit5to10.currentValue;
      if (this.isSplit5to10) {
        this.tutorialContent.TN_image_13 = 'Tutorial_13_Splits_5-9@2x.webp';
      } else {
        this.tutorialContent.TN_image_13 = 'Tutorial_13_Splits_1-10@2x.webp';
      }
    }
    /*if (data.currentSplitCardObj) {
      this.currentSplitCardObj = data.currentSplitCardObj.currentValue;
      this.splitCard1 = this.currentSplitCardObj.splitCard1 ? this.currentSplitCardObj.splitCard1 : 'green_5';
      this.splitCard2 = this.currentSplitCardObj.splitCard2 ? this.currentSplitCardObj.splitCard2 : 'blue_5';
    }
    if (data.superNaturalCardObj) {
      this.superNaturalCardObj = data.superNaturalCardObj.currentValue;
      this.superNaturalCard1 = this.superNaturalCardObj.superNaturalCard1 ? this.superNaturalCardObj.superNaturalCard1 : 'green_11';
      this.superNaturalCard2 = this.superNaturalCardObj.superNaturalCard2 ? this.superNaturalCardObj.superNaturalCard2 : 'orange_11';
    }
    if (data.doubleNaturalCardObj) {
      this.doubleNaturalCardObj = data.doubleNaturalCardObj.currentValue;
      this.doubleNaturalCard1 = this.doubleNaturalCardObj.doubleNaturalCard1 ? this.doubleNaturalCardObj.doubleNaturalCard1 : 'white_7';
      this.doubleNaturalCard2 = this.doubleNaturalCardObj.doubleNaturalCard2 ? this.doubleNaturalCardObj.doubleNaturalCard2 : 'white_7';
    }
    if (data.naturalZeroCardObj) {
      this.naturalZeroCardObj = data.naturalZeroCardObj.currentValue;
      this.naturalZeroCard1 = this.naturalZeroCardObj.naturalZeroCard1 ? this.naturalZeroCardObj.naturalZeroCard1 : 'white_5';
      this.naturalZeroCard2 = this.naturalZeroCardObj.naturalZeroCard2 ? this.naturalZeroCardObj.naturalZeroCard2 : 'blue_5';
    }*/
    if (data.overlayScreenDisplay) {
      let display: number = data.overlayScreenDisplay.currentValue;
      if (display == 0) {
        this.tutorialPageCountemit.emit(0);
        this.tutorialPageCount = 0;
        this.tutorialCount = 0;
        this.buttonClick('close');
      }
    }

    if (data.tutorialPageCount) {
      this.tutorialPageCount = data.tutorialPageCount.currentValue;
      this.tutorialClickFromParent(this.tutorialPageCount);
      this.updateTutorialContent();
    }
    this.pays_blank_tutorial = {
      TN_pays_blank_position_0: [],
      TN_pays_blank_position_1: [],
      TN_pays_blank_position_2: [],
      TN_pays_blank_position_3: [],
      TN_pays_blank_position_4: [],
      TN_pays_blank_position_5: [],
      TN_pays_blank_position_6: [],
      TN_pays_blank_position_7: [],
      TN_pays_blank_position_8: [
        {
          paysContent: this.percentageContent[this.data.supernaturalpercentage], //'LANG00888',//(this.language == 'ar' || this.language == 'he' ? 'LANG00783' : 'LANG00786'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturaltwentyonepercentage
              : this.data.naturaltwentyonepercentage + '%',
          width: 128,
          height: 46,
          left: 299,
          top: 383,
          top_pays_blank_small: 387,
        },
      ],
      TN_pays_blank_position_9: [
        {
          paysContent:
            this.percentageContent[this.data.naturaltwentyonepercentage], //'LANG00888',//(this.language == 'ar' || this.language == 'he' ? 'LANG00783' : 'LANG00786'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturaltwentyonepercentage
              : this.data.naturaltwentyonepercentage + '%',
          width: 128,
          height: 46,
          left: 299,
          top: 383,
          top_pays_blank_small: 387,
        },
      ],
      TN_pays_blank_position_10: [
        {
          paysContent:
            this.percentageContent[this.data.doublenaturalpercentage], //'LANG00885',//(this.language == 'ar' || this.language == 'he' ? 'LANG00786' : 'LANG00783'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.doublenaturalpercentage
              : this.data.doublenaturalpercentage + '%',
          width: 128,
          height: 46,
          left: 299,
          top: 383,
          top_pays_blank_small: 387,
        },
      ],
      TN_pays_blank_position_11: [
        {
          paysContent: this.percentageContent[this.data.naturalzeropercentage], //'LANG00885',//(this.language == 'ar' || this.language == 'he' ? 'LANG00784' : 'LANG00783'),
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturalzeropercentage
              : this.data.naturalzeropercentage + '%',
          width: 128,
          height: 46,
          left: 299,
          top: 383,
          top_pays_blank_small: 387,
        },
      ],
      TN_pays_blank_position_12: [],
      TN_pays_blank_position_13: [],
      TN_pays_blank_position_14: [],
      TN_pays_blank_position_15: [],
      TN_pays_blank_position_16: [
        {
          paysContent:
            this.percentageContent[this.data.colorcardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.colorcardinsurancepercentage
              : this.data.colorcardinsurancepercentage + '%',
          width: 128,
          height: 46,
          left: TutorialsPortraitProps[this.language]
            .TN_pays_blank_position_16_Left,
          top: TutorialsPortraitProps[this.language]
            .TN_pays_blank_position_16_Top,
          top_pays_blank_small:
            TutorialsPortraitProps[this.language]
              .TN_pays_blank_position_16_Top_pays_blank_small,
        },
      ],
      TN_pays_blank_position_17: [
        {
          paysContent:
            this.percentageContent[this.data.whitecardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.whitecardinsurancepercentage
              : this.data.whitecardinsurancepercentage + '%',
          width: 128,
          height: 46,
          left: TutorialsPortraitProps[this.language]
            .TN_pays_blank_position_17_Left,
          top: TutorialsPortraitProps[this.language]
            .TN_pays_blank_position_17_Top,
          top_pays_blank_small:
            TutorialsPortraitProps[this.language]
              .TN_pays_blank_position_17_Top_pays_blank_small,
        },
      ],
      TN_pays_blank_position_18: [
        {
          paysContent:
            this.language == 'ar' || this.language == 'he'
              ? this.percentageContent[this.data.russianroulette20percentage]
              : this.percentageContent[this.data.russianroulette17percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette20percentage
              : this.data.russianroulette17percentage + '%',
          width: 128,
          height: 46,
          top: 413,
          top_pays_blank_small: 413,
          left: {
            ar: 77,
            hy: 69,
            bg: 74,
            kh: 69,
            'zh-Hans': 73,
            'zh-Hant': 73,
            cs: 72,
            da: 73,
            nl: 71,
            en: 73,
            ee: 69,
            ph: 66,
            fi: 75,
            fr: 75,
            ge: 69,
            de: 75,
            gr: 71,
            he: 77,
            'hi-IN': 72,
            hu: 70,
            id: 72,
            it: 62,
            ja: 71,
            ko: 73,
            lv: 67,
            lt: 71,
            my: 70,
            mt: 73,
            nb: 70,
            pl: 70,
            'pt-BR': 73,
            ro: 73,
            ru: 73,
            'sr-RS': 73,
            sk: 73,
            si: 68,
            es: 73,
            sv: 70,
            'ta-IN': 63,
            th: 70,
            tr: 65,
            ua: 70,
            vi: 65,
          },
        },
        {
          paysContent:
            this.language == 'ar' || this.language == 'he'
              ? this.percentageContent[this.data.russianroulette19percentage]
              : this.percentageContent[this.data.russianroulette18percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette19percentage
              : this.data.russianroulette18percentage + '%',
          width: 128,
          height: 46,
          top: 413,
          top_pays_blank_small: 413,
          left: {
            ar: 223,
            hy: 217,
            bg: 223,
            kh: 225,
            'zh-Hans': 223,
            'zh-Hant': 223,
            cs: 224,
            da: 222,
            nl: 224,
            en: 224,
            ee: 219,
            ph: 214,
            fi: 227,
            fr: 226,
            ge: 217,
            de: 226,
            gr: 221,
            he: 224,
            'hi-IN': 222,
            hu: 218,
            id: 223,
            it: 216,
            ja: 227,
            ko: 223,
            lv: 216,
            lt: 219,
            my: 220,
            mt: 219,
            nb: 224,
            pl: 220,
            'pt-BR': 223,
            ro: 223,
            ru: 223,
            'sr-RS': 223,
            sk: 223,
            si: 218,
            es: 221,
            sv: 224,
            'ta-IN': 225,
            th: 217,
            tr: 216,
            ua: 221,
            vi: 220,
          },
        },
        {
          paysContent:
            this.language == 'he' || this.language == 'ar'
              ? this.percentageContent[this.data.russianroulette18percentage]
              : this.percentageContent[this.data.russianroulette19percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette18percentage
              : this.data.russianroulette19percentage + '%',
          width: 128,
          height: 46,
          top: 413,
          top_pays_blank_small: 413,
          left: {
            ar: 366,
            hy: 369,
            bg: 372,
            kh: 367,
            'zh-Hans': 372,
            'zh-Hant': 372,
            cs: 372,
            da: 364,
            nl: 367,
            en: 375,
            ee: 365,
            ph: 363,
            fi: 378,
            fr: 373,
            ge: 371,
            de: 365,
            gr: 374,
            he: 366,
            'hi-IN': 376,
            hu: 368,
            id: 371,
            it: 372,
            ja: 371,
            ko: 372,
            lv: 365,
            lt: 365,
            my: 366,
            mt: 372,
            nb: 370,
            pl: 369,
            'pt-BR': 371,
            ro: 372,
            ru: 372,
            'sr-RS': 372,
            sk: 372,
            si: 368,
            es: 371,
            sv: 371,
            'ta-IN': 376,
            th: 362,
            tr: 368,
            ua: 373,
            vi: 374,
          },
        },
        {
          paysContent:
            this.language == 'he' || this.language == 'ar'
              ? this.percentageContent[this.data.russianroulette17percentage]
              : this.percentageContent[this.data.russianroulette20percentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.russianroulette17percentage
              : this.data.russianroulette20percentage + '%',
          width: 128,
          height: 46,
          top: 413,
          top_pays_blank_small: 413,
          left: {
            ar: 516,
            hy: 521,
            bg: 519,
            kh: 516,
            'zh-Hans': 520,
            'zh-Hant': 520,
            cs: 523,
            da: 515,
            nl: 516,
            en: 525,
            ee: 512,
            ph: 511,
            fi: 524,
            fr: 523,
            ge: 521,
            de: 515,
            gr: 521,
            he: 517,
            'hi-IN': 521,
            hu: 514,
            id: 519,
            it: 525,
            ja: 524,
            ko: 520,
            lv: 516,
            lt: 518,
            my: 511,
            mt: 515,
            nb: 515,
            pl: 516,
            'pt-BR': 520,
            ro: 520,
            ru: 520,
            'sr-RS': 520,
            sk: 520,
            si: 516,
            es: 520,
            sv: 518,
            'ta-IN': 526,
            th: 513,
            tr: 518,
            ua: 517,
            vi: 529,
          },
        },
      ],
      TN_pays_blank_position_19: [
        {
          paysContent: this.percentageContent[this.data.supernaturalpercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.supernaturalpercentage
              : this.data.supernaturalpercentage + '%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 110 - 5,
          top_pays_blank_small: 110,
        },
        {
          paysContent:
            this.percentageContent[this.data.naturaltwentyonepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturaltwentyonepercentage
              : this.data.naturaltwentyonepercentage + '%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 161 - 5,
          top_pays_blank_small: 161,
        },
        {
          paysContent:
            this.percentageContent[this.data.doublenaturalpercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.doublenaturalpercentage
              : this.data.doublenaturalpercentage + '%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 212 - 5,
          top_pays_blank_small: 212,
        },
        {
          paysContent: this.percentageContent[this.data.naturalzeropercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.naturalzeropercentage
              : this.data.naturalzeropercentage + '%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 263 - 5,
          top_pays_blank_small: 263,
        },
        {
          paysContent: 'LANG00885', //(this.language == 'ar' || this.language == 'he' ? 'LANG00783' : 'LANG00783'),
          percentageContent:
            this.language == 'ar' || this.language == 'he' ? '%100' : '100%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 314 - 5,
          top_pays_blank_small: 314,
        },
        {
          paysContent:
            this.percentageContent[this.data.colorcardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.colorcardinsurancepercentage
              : this.data.colorcardinsurancepercentage + '%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 366 - 5,
          top_pays_blank_small: 366,
        },
        {
          paysContent:
            this.percentageContent[this.data.whitecardinsurancepercentage],
          percentageContent:
            this.language == 'he' || this.language == 'ar'
              ? '%' + this.data.whitecardinsurancepercentage
              : this.data.whitecardinsurancepercentage + '%',
          width: this.language == 'lt' || this.language == 'es' ? 124 : 128,
          height: 46,
          left: this.language == 'ar' || this.language == 'he' ? 522 : 62,
          top: 420 - 5,
          top_pays_blank_small: 420,
        },
      ],
      TN_pays_blank_position_20: [],
      TN_pays_blank_position_21: [],
    };
    this.tutorialPortraitPropsConst = TutorialsPortraitProps[this.language];
    this.fontTranslationConst = FontTranslationProp[this.language];
  }

  updateTutorialContent() {
    this.language =
      this.translate.currentLang == 'desc' ||
      this.translate.currentLang == 'code'
        ? 'en'
        : this.translate.currentLang;
    this.percentageContentFont =
      FontTranslationProp[this.language].footerBetFontFamily;
    this.paysContentFont =
      FontTranslationProp[this.language].fc21paysTextFontFamily;
    this.paysContentFontSize =
      FontTranslationProp[this.language].paysContentFontSize;
    this.percentageContentFontSize =
      FontTranslationProp[this.language].percentageContentFontSize;
    this.fontTranslationConst = FontTranslationProp[this.language];
  }
  /*onLangClick(langcode) {
 //console.log("langcode",langcode);
   this.language = langcode;
   }*/

  ngOnInit() {
    this.language =
      this.translate.currentLang == 'desc' ||
      this.translate.currentLang == 'code'
        ? 'en'
        : this.translate.currentLang;
    this._utilService.loadfc21TutorialManifest();
  }

  ngAfterViewInit() {}

  tutorialClick(value) {
    if (this.language == 'he' || this.language == 'ar') {
      this.tutorialCount = this.tutorialClickArrayHebrew[value];
    } else {
      this.tutorialCount = this.tutorialClickArray[value];
    }
    if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
      this.firebaseAnalyticsServices.sendAction(
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventAction,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
        FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
      );
    }
  }

  tutorialClickFromParent(value) {
    this.tutorialCount = this.tutorialClickArrayFromParent[value];
  }

  buttonClick(value) {
    //console.log("buttonClick : "+value+' len : '+Object.keys(this.tutorialContent).length+" tutorialCount : "+this.tutorialCount);
    let contentObj: Object = this.tutorialContent;
    switch (value) {
      case 'left':
        if (this.isDisplayAllButtons) {
          this.tutorialCount > 0
            ? this.tutorialCount--
            : (this.tutorialCount = this.TotalTutorialCount);
          // console.log(this.tutorialCount);
          this.tutorialPageCountemit.emit({
            direction: 'left',
            tutorialCount: this.tutorialCount,
          });
        }
        if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]
              .eventAction,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
          );
        }
        break;
      case 'right':
        if (this.isDisplayAllButtons) {
          this.tutorialCount < this.TotalTutorialCount
            ? this.tutorialCount++
            : (this.tutorialCount = 0);
          // console.log(this.tutorialCount);
          this.tutorialPageCountemit.emit({
            direction: 'right',
            tutorialCount: this.tutorialCount,
          });
        }
        if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]
              .eventAction,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
          );
        }
        break;
      case 'home':
        this.display = 1;
        this.tutorialCount = 0;
        if (FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]) {
          this.firebaseAnalyticsServices.sendAction(
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount]
              .eventAction,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].category,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].Label,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].catId,
            FirebaseConstant.TutorialsPopup_FC21[this.tutorialCount].eventId
          );
        }
        break;
      case 'close':
        if (this.isDisplayAllButtons) {
          // this.tutorialPageCountemit.emit(0);
          this.tutorialPageCount = 0;
          this.display = 0;
          if (this.canPlayGame) {
            // this.audioService.playVoiceSounds(['returntogame']);
          }
          // console.log("44-->audio-->returntogame");
          this.tutorialsChange.emit({ name: 'close' });
        }
        break;
      default:
        break;
    }
    this.updateTutorialContent();
    //console.log("this.soundvolume : "+this.soundvolume+"this.tutorialCount : "+this.tutorialCount+" name : "+contentObj['TN_image_'+this.tutorialCount]);
  }

  onTouchStart(event: TouchEvent): void {
    /*if (event.touches.length == 2) {
     // if(this.scalVal <= 1) {
     let diffX = Math.abs(event.touches[0].clientX - event.touches[1].clientX);
     let diffY = Math.abs(event.touches[0].clientY - event.touches[1].clientY);
     this.touchStartVal = Math.max(diffX, diffY);
     event.preventDefault();
     let medianX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
     let medianY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
     this.touchX = (Math.floor((medianX / this.scaleWidth) * 100) > 100) ? 100 : Math.floor((medianX / this.scaleWidth) * 100);
     this.touchY = (Math.floor((medianY / this.scaleHeight) * 100) > 100) ? 100 : Math.floor((medianY / this.scaleHeight) * 100);
     }*/
  }

  onTouchMove(event: TouchEvent): void {
    /*let len = event.touches.length;
     if (len == 2) {
     this.handle_pinch_zoom(event);
     event.preventDefault();
     } else {
     event.preventDefault();
     }*/
  }

  handle_pinch_zoom = (event) => {
    /*let diffX = Math.abs(event.touches[0].clientX - event.touches[1].clientX);
     let diffY = Math.abs(event.touches[0].clientY - event.touches[1].clientY);
     this.touchMoveVal = Math.max(diffX, diffY);
     let finalVal = this.touchMoveVal / this.touchStartVal;
     /!*this.val = this.scalVal;*!/
     if (this.scaleValOnTouchEnd <= 1) {
     this.scalVal = (finalVal <= 1) ? 1 : (finalVal >= 4) ? 4 : finalVal;
     } else {
     let value = (finalVal + this.scaleValOnTouchEnd) - 1;
     this.scalVal = ((value) <= 1) ? 1 : ((value) >= 4 ? 4 : (value));
     }
     let medianX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
     let medianY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
     this.touchX = (Math.floor(((medianX / this.scaleWidth) * 100) - this.minusXValue) > 100) ? 100 : Math.floor(((medianX / this.scaleWidth) * 100) - this.minusXValue);
     this.touchY = (Math.floor(((medianY / this.scaleHeight) * 100) - this.minusYValue) > 100) ? 100 : Math.floor(((medianY / this.scaleHeight) * 100) - this.minusYValue);*/
  };

  onTouchEnd = (scaleValue) => {
    this.scaleValOnTouchEnd = scaleValue;
  };

  getCardImage(cardValue) {
    // return SpriteController.getImageFromSprite(SpriteImage.simulatorcardsprite, SpriteImage.simulatorcards, SpriteImage.simulatorcardsjson, cardValue);
  }

  getImageFromQuickTipsSprite(imageName) {
    // return SpriteController.getImageFromSprite(SpriteImage.quicktipssprite, SpriteImage.quicktipsasset, SpriteImage.quicktipsspritejson, imageName);
  }

  onGeneralInfoClick = () => {
    if (Settings.appSettings.menu.fc21.tutorials.Generalgameinfo) {
      this.tutorialCount = 22;
    }
  };

  ngOnDestory() {
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
  }
}
